module.exports = __webpack_public_path__ + "img/icn_live_white.a3fd923a.svg";